var map = {
	"./en/common.json": "CeDy",
	"./id/common.json": "aEcW",
	"./my/common.json": "l0yX",
	"./ph/common.json": "lrgu",
	"./th/common.json": "jI3O",
	"./vn/common.json": "8OqB"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g8N8";